import type { HeadedOutDisplayRow, HeadedOutKind, HeadedOutRow } from './types';

export function formatTimeLabel(kind: HeadedOutKind, plannedAt: Date | null): string {
  if (kind === 'now') return 'Now';
  if (!plannedAt) return '';
  const s = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Denver',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  }).format(plannedAt);
  return `at ${s.replace(/\s?[AP]M$/i, '')}`;
}

export function sortRows(a: HeadedOutRow, b: HeadedOutRow): number {
  // Now rows first
  if (a.kind === 'now' && b.kind !== 'now') return -1;
  if (b.kind === 'now' && a.kind !== 'now') return 1;
  // Both now: stable by createdAt, then id
  if (a.kind === 'now' && b.kind === 'now') {
    const ac = a.createdAt.getTime();
    const bc = b.createdAt.getTime();
    if (ac !== bc) return ac - bc;
    return a.id.localeCompare(b.id);
  }
  // Both later: plannedAt, then createdAt, then id
  const at = a.plannedAt?.getTime() ?? 0;
  const bt = b.plannedAt?.getTime() ?? 0;
  if (at !== bt) return at - bt;
  const ac = a.createdAt.getTime();
  const bc = b.createdAt.getTime();
  if (ac !== bc) return ac - bc;
  return a.id.localeCompare(b.id);
}

export function toDisplayRows(
  rows: HeadedOutRow[],
  familyIdToName: Record<string, string>,
  parkIdToName: Record<string, string>,
  myFamilyId: string | null
): HeadedOutDisplayRow[] {
  return rows
    .slice()
    .sort(sortRows)
    .map((r) => {
      const isOwnFamily = myFamilyId != null && r.familyId === myFamilyId;
      const whenLabel = formatTimeLabel(r.kind, r.plannedAt);
      let action: HeadedOutDisplayRow['action'] = { kind: 'none' };
      if (isOwnFamily) {
        if (r.kind === 'now') action = { kind: 'left', label: "We've left" };
        if (r.kind === 'later') action = { kind: 'cancel', label: 'Cancel' };
      }
      return {
        id: r.id,
        familyName: familyIdToName[r.familyId] ?? 'Family',
        parkName: parkIdToName[r.parkId] ?? 'Park',
        whenLabel,
        isOwnFamily,
        action,
      };
    });
}

